export const CONTRACTS_CSV_URL = "/v2/csv-contracts";
export const ENTITIES_CSV_URL = {
  JOBS: "/v2/jobs/get-csv"
};
// eslint-disable-next-line no-undef
export const BASE_URL = process?.env.REACT_APP_API_URL;
